import React from 'react'
import Header from './components/Header'
import Bookings from './components/Bookings'
import { NoBookings } from './components/NoBookings'
import { makeStyles } from '@material-ui/core/styles'
import { useMyBookings } from './hooks/useMyBookings'
import { extractResponse } from '../../utils'

const useStyles = makeStyles((theme) => {
    return {
        container: {
            margin: 'auto',
            minHeight: '90vh',
            paddingBottom: theme.spacing(9),
        },
    }
})

export const MyBookings = () => {
    const classes = useStyles()
    const { data } = useMyBookings()

    return (
        <div className={classes.container}>
            <Header />
            {extractResponse(data)?.data?.length === 0 ? <NoBookings /> : <Bookings />}
        </div>
    )
}
